import type { IAppState } from "../core/redux/IAppState";
import { PRODUCT_ADMINISTRATION_ROUTE, PRODUCT_MAPPING_ROUTE, REPORTS_ROUTE, SYSTEM_ADMIN_ROUTE, USER_MANAGEMENT_ROUTE, VALIDATION_CONFIGURATION_ROUTE } from "../core/routes";

export function getRequiredRolesForPath(
  state: IAppState,
  pathname: string
): string[] | undefined {
  const path = pathname.replace(/\/$/, "");

  const config = state.resortToolsConfig;

  const viewReports = [...new Set([...config.enableHotlistReport, ...config.enableGuestHydrationReport, ...config.enableWeeklyVisitorReport])];

  if (path.startsWith(SYSTEM_ADMIN_ROUTE)) {
    return config.manageSystemAdmin;
  }

  if (path.startsWith(USER_MANAGEMENT_ROUTE)) {
    return config.manageUsers
  }

  if (path.startsWith(PRODUCT_MAPPING_ROUTE)) {
    return config.enableProductMapping;
  }

  if (path.startsWith(VALIDATION_CONFIGURATION_ROUTE)) {
    return config.manageValidationConfiguration;
  }

  if (path.startsWith(REPORTS_ROUTE)) {
    return viewReports;
  }

  if (path.startsWith(PRODUCT_ADMINISTRATION_ROUTE)) {
    return config.manageProductAdministration;
  }

  return undefined; // no restriction
}

